module.exports = __webpack_public_path__ + "static/Ecosystem-icon-11-b637a9f44e990a93e769edd3305a9ee0.png";